import React from "react";
import Header from "../Header";
import BaseContainerDividingLineRHSSidebar from "../BaseContainerDividingLineRHSSidebar";
import s1 from "../../img/screen1.png"; 
import s2 from "../../img/screen2.png"; 
import s3 from "../../img/screen3.png"; 
import s4 from "../../img/screen4.png"; 
import s5 from "../../img/screen5.png"; 
import "./DashboardHomePage.css";

const DashboardHomePage = () => {

  return (
    <div className="container-center-horizontal">
      <div className="dashboard-home-page screen">
        <div className="flex-col-22">
          <Header />
          <div className="main-screen-container">
           <BaseContainerDividingLineRHSSidebar />
           <img className="s1" src={s1} />
           <img className="s2" src={s2} />
           <img className="s3" src={s3} />
           <img className="s4" src={s4} />
           <img className="s5" src={s5} /> 
           <div className="change-plan">
              <div className="change-plan-1 nunito-bold-blue-italic-30px">Beyond the Tradition</div>
          </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashboardHomePage;
